import $ from "jquery";
import {language_switcher_init} from "./nomadia/language_switcher";
import {init_navigation} from "./nomadia/navigation";
import {init_features_grid} from "./nomadia/flexible-content-blocs/features-grid";
import {init_cards_blocs_same_height} from "./nomadia/flexible-content-blocs/cards";
import {init_multifeatures as init_multifeatures_spotlight} from "./nomadia/flexible-content-blocs/multifeatures-spotlight";
import {init_archive_page} from "./nomadia/commons/archive-page";
import {init_multifeature} from "./nomadia/flexible-content-blocs/multifeature";
import {switcher_checkbox as init_switcher_checkbox} from "./nomadia/flexible-content-blocs/switcher_checkbox";
import {customers_marquee as init_customers_marquee} from "./nomadia/flexible-content-blocs/customers_marquee";
import {init_responsive_embed} from "./nomadia/commons/responsive-embed";
import {init_animation} from "./nomadia/commons/animation";
import {share as init_sharing_link} from "./nomadia/commons/share";
import {init_embed_video_in_modal} from "./nomadia/flexible-content-blocs/embed_video_modal.js";
import {init_neosafe_api} from "./nomadia/neosafe/neosafe_api.js";
import {init_testimonials} from "./nomadia/flexible-content-blocs/testimonials.js";

const bootstrap = require('bootstrap');

const app_initialisation = () => {
    init_navigation();
    init_neosafe_api();
    language_switcher_init();
    init_features_grid();
    init_cards_blocs_same_height();
    init_multifeatures_spotlight();
    init_multifeature();
    init_archive_page();
    init_switcher_checkbox();
    init_customers_marquee();
    init_responsive_embed();
    init_embed_video_in_modal();
    init_testimonials();
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })
    init_animation();
    init_sharing_link();
}

$(function() {
    app_initialisation();
});


$( window ).on("load", () => {
    // init_cards_blocs_same_height();
    // init_features_grid();
})